/**
 * materialGraphStore — which material's node graph is open in the editor.
 *
 * Module singleton + subscribe, the same shape as versionPanelStore and
 * bakeSettingsStore.
 *
 * The graph editor used to be a fullscreen modal mounted INSIDE ContentBrowser,
 * which had two consequences worth stating because they are the reason this
 * file exists:
 *
 *   - it covered the content browser, so dragging a texture from the browser
 *     onto a Texture Sample node was not merely unimplemented, it was
 *     impossible — there was nothing on screen to drag FROM;
 *   - it lived inside the collapsible assets dock, so the dock owned the
 *     lifetime of an editor that has to outlive it.
 *
 * As a FloatingWindow mounted at shell level, neither holds. The asset is kept
 * here rather than in ContentBrowser state so the window survives the dock
 * being collapsed, and so any future door (outliner row, menu command) opens
 * the same one editor rather than a second copy.
 *
 * Not persisted: geometry belongs to windowStore, but which material was open
 * is session state — reopening someone's last material on boot is noise.
 */
let state = { asset: null }
const listeners = new Set()

function emit() {
  if (typeof window !== 'undefined') window.__MATERIAL_GRAPH__ = state
  for (const fn of listeners) fn()
}

export const materialGraphStore = {
  getState() { return state },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn) },
  /** @param {object} asset content-browser asset row (needs rawId + name). */
  open(asset) { state = { asset }; emit() },
  close() { if (state.asset) { state = { asset: null }; emit() } },
}

export default materialGraphStore
